import Head from "next/head";

import useLayoutStore from "@/store/useLayoutStore";

const MetaTag = () => {
  const title = useLayoutStore.useTitle();

  return (
    <Head>
      <link rel="shortcut icon" href="/favicon.ico" />
      <title>{`MyConnect ${title ? `- ${title}` : ""}`}</title>
    </Head>
  );
};

export default MetaTag;
